/**
 * What happened to a supplier's risk management assignment, as recorded on the audit trail.
 */
export enum RiskManagementAssignmentAction {
  /** A user was assigned to a supplier which had nobody assigned to it. */
  Assigned = 0,
  /** A user replaced somebody else on a supplier. The replaced user is the previous assignee. */
  Reassigned = 1,
  /** The assignment was removed, leaving the supplier unassigned. */
  Unassigned = 2,
}

export const ASSIGNMENT_ACTION_LABELS: Record<RiskManagementAssignmentAction, string> = {
  [RiskManagementAssignmentAction.Assigned]: 'Assigned',
  [RiskManagementAssignmentAction.Reassigned]: 'Reassigned',
  [RiskManagementAssignmentAction.Unassigned]: 'Unassigned',
};
